import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100vw;
  padding: 2rem 3.6rem;

  .logo {
    position: absolute;
    top: 2rem;
    left: 3.6rem;
  }
`;

export const PaymentInfo = styled.div`
  h1 {
    font-size: 3.6rem;
    text-align: center;
    margin-bottom: 3.6rem;
  }
  .plan {
    font-size: 2.4rem;
    text-transform: capitalize;
  }

  .price {
    font-size: 3rem;
    font-weight: bold;
  }

  .plan-price-wrapper {
    gap: 4.8rem;
  }
  .alter-plan {
    font-size: 1.2rem;
    cursor: pointer;
    color: #d97706;
    border-bottom: 1px solid #d97706;
    transition: all 0.2s ease-in-out;
    width: fit-content;
    &:hover {
      border-bottom: 1px solid transparent;
    }

    margin-bottom: 2.6rem;
  }

  .code {
    width: 20rem;
    height: 20rem;
    align-self: center;
  }

  button {
    max-width: 80%;
    min-width: 80%;
    align-self: center;
    margin-top: 1rem;
  }
`;

export const CpfCnpjWrapper = styled.div`
  margin: 1.5rem 0 0.5rem 0;
  max-width: 80%;
  min-width: 80%;
  span {
    font-size: 1rem;
    color: #888;
    margin-top: 0.2rem;
    margin-bottom: 1.2rem;
  }
`;

export const CpfCnpjInput = styled.input`
  width: 100%;
  padding: 0.8rem 1rem;
  border-radius: 0.6rem;
  border: 1px solid #ccc;
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
`;
